module.exports = __webpack_public_path__ + "img/06-kiosk.639597fa.png";